import { PropsWithChildren } from 'react';

export function Incase(props: PropsWithChildren<{ of: any }>) {
  return Boolean(props.of) && props.children ? <>{props.children}</> : null;
}
